"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = require("react");
var ToastContext_1 = __importDefault(require("../ToastContext/ToastContext"));
var useToasts = function () {
    var ctx = react_1.useContext(ToastContext_1["default"]);
    if (!ctx) {
        throw Error("The `useToasts` hook must be called from a descendent of the `ToastProvider`.");
    }
    return {
        addToast: ctx.add,
        removeAllToasts: ctx.removeAll,
        removeToast: ctx.remove,
        toastStack: ctx.toasts,
        updateToast: ctx.update
    };
};
exports["default"] = useToasts;
